import { render, staticRenderFns } from "./FriendMeta.vue?vue&type=template&id=3ab8c946&scoped=true"
import script from "./FriendMeta.vue?vue&type=script&lang=js"
export * from "./FriendMeta.vue?vue&type=script&lang=js"
import style0 from "./FriendMeta.vue?vue&type=style&index=0&id=3ab8c946&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab8c946",
  null
  
)

export default component.exports